export default {
  formatTime(lapsed, showMs) {
    // if (lapsed == null) return '--';
    if (lapsed == null || lapsed < 0) lapsed = 0;
    if (lapsed === undefined || lapsed === null) {
      lapsed = this.lapsedMillisecondsSession;
    }

    let time = this.formatHours(lapsed) +
      ':' + this.formatMinutes(lapsed) +
      ':' + this.formatSeconds(lapsed);
    if (this.millisecondsDigitAmount > 0 && showMs) {
      time += this.millisecondsSeparator +
        this.formatMilliseconds(lapsed).substring(0, this.millisecondsDigitAmount);
    }

    return time;
  },
  formatHours(lapsed) {
    const hrs = Math.floor((lapsed / 1000 / 60 / 60));
    return hrs >= 10 ? hrs : '0' + hrs;
  },
  formatMinutes(lapsed) {
    const min = Math.floor((lapsed / 1000 / 60) % 60);
    return min >= 10 ? min : '0' + min;
  },
  formatSeconds(lapsed) {
    const sec = Math.floor((lapsed / 1000) % 60);
    return sec >= 10 ? sec : '0' + sec;
  },
  formatDate(time) {
    const date = new Date(time);
    return date.toString()
  },
  formatMilliseconds(lapsed) {
    const mil = Math.ceil(lapsed % 1000);

    if (mil < 10) {
      return '00' + mil;
    } else if (mil < 100) {
      return '0' + mil;
    } else {
      return '' + mil;
    }
  },
};